//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18n from "@/utils/i18n";
export default {
  name: "validation-editor",
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  data: function data() {
    return {
      fieldValidators: [{
        value: 'number',
        label: this.i18nt('designer.hint.numberValidator')
      }, {
        value: 'letter',
        label: this.i18nt('designer.hint.letterValidator')
      }, {
        value: 'letterAndNumber',
        label: this.i18nt('designer.hint.letterAndNumberValidator')
      }, {
        value: 'mobilePhone',
        label: this.i18nt('designer.hint.mobilePhoneValidator')
      }, {
        value: 'email',
        label: this.i18nt('designer.hint.emailValidator')
      }, {
        value: 'url',
        label: this.i18nt('designer.hint.urlValidator')
      }, {
        value: 'noChinese',
        label: this.i18nt('designer.hint.noChineseValidator')
      }, {
        value: 'chinese',
        label: this.i18nt('designer.hint.chineseValidator')
      }]
    };
  }
};